import { Grid } from '@mui/material';
import { FC } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import { APP_URLS } from 'src/constants';
import { Typography } from 'src/components';
import { useAuth } from 'src/contexts';

const NonAuthLayout: FC = () => {
  const location = useLocation();
  const { isAI, isDI } = useAuth();

  return (
    <>
      <nav
        aria-label="Horizontal School Form Navigation"
        className="cb-menu-list cb-menu-list-horizontal position-sticky cb-border-bottom cb-box-shadow-bottom cb-white-bg display-flex justify-content-xs-between align-items-xs-center"
        style={{ height: 56, paddingLeft: 16, top: 0, zIndex: 100 }}>
        {location.pathname !== '/' ?  isAI ? (
          <Typography variant="h3" style={{ fontWeight: 'bold' }}>
            School Code Request Form
          </Typography>
        ) : ( isDI ? (
          <Typography variant="h3" style={{ fontWeight: 'bold' }}>
            Score Send Code Request Form
          </Typography>
        ) 
        : (
          <div />
        )) : (
          <div />
        ) }

        <ul>
          <li>
            <Link className="cb-menu-link" to="/">
              Home
            </Link>
          </li>
          <li>
            <Link className="cb-menu-link" to={APP_URLS.LOGIN}>
              Log In
            </Link>
          </li>
          <li>
            <Link className="cb-menu-link" to={APP_URLS.REGISTER}>
              Sign Up
            </Link>
          </li>
          <li>
            <Link className="cb-menu-link" to={APP_URLS.FORGOT_PASSWORD}>
              Forgot Password
            </Link>
          </li>
        </ul>
      </nav>
      <Grid container justifyContent="stretch">
        <Grid item xs={12}>
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
};

export default NonAuthLayout;
